import styled, { css } from 'styled-components';
import FONTS from '../../constants/fonts.js';
import FontSize from '../../constants/fontSize.js';
import COLORS from '../../constants/colors.js';
import { Breakpoint } from '../../constants/breakpoint.js';

const StyledRequiredSymbol = styled.span `
    color: ${COLORS.RED_800};
`;
const StyledTypography = styled.span `
    /* min-width: fit-content; */
    padding: 0;
    margin: 0;
    font-size: ${({ size }) => (size ? `${FontSize[size]}rem` : "inherit")};
    text-align: ${({ align }) => align};
    color: ${({ color }) => color};
    font-family: ${({ weight }) => weight && FONTS[weight.toUpperCase()]};
    font-style: ${({ italic }) => italic && "italic"};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-transform: ${({ textTransform }) => textTransform};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "1.5em")};
    white-space: ${({ preWrap }) => (preWrap ? "pre-wrap" : "inherit")};
    cursor: ${({ onClick }) => (onClick ? "pointer" : "inherit")};

    ${({ noWrap }) => noWrap &&
    css `
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `};

    ${({ preventSelect }) => preventSelect &&
    css `
            -webkit-user-select: none; /* Safari */
            -ms-user-select: none; /* IE 10 and IE 11 */
            user-select: none; /* Standard syntax */
        `};

    ${({ strike }) => strike &&
    css `
            text-decoration: line-through;
            /* optional */
            text-decoration-thickness: 2px;
            text-decoration-color: currentColor;
            text-decoration-style: solid;
        `};

    @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
        ${({ mSize }) => (mSize ? `font-size:  ${FontSize[mSize]}rem` : ``)}
    }
`;

export { StyledRequiredSymbol, StyledTypography as default };
//# sourceMappingURL=Typography.styles.js.map
